import { config } from '../../../config/config';

import getStorage from './get-storage';

export const getVersion = () => {
  const isProd = window.location.host.includes('powerplay.com');

  return { isProd };
};

export const getVariables = () => {
  const defaults = {
    path: window.location.pathname,
    search: window.location.search,
    host: window.location.host,
    language: navigator.language.includes('fr') ? 'fr' : 'en',
    countries: ['CA'],
    customerUserIdKey: '_cui',
    welcomeBonusKey: 'wb',
    downTimeKey: 'dtp',
    affiliatesKey: 'affiliates',
    regConfirmKey: 'regconfirm',
    firstDepositConfirmKey: 'ftdconfirm',
    themeKey: 'pp-theme',
    liveChatKey: 'live-chat',
    languageKey: 'language',
    activeLinkKey: 'activeLink',
    loginPopupKey: 'loginPopup',
    exitPopupKey: 'exitPopup',
    settingsKey: 'settings',
    notificationKey: 'pp-notifications',
    firstVisitKey: 'pp-fvo',
    googleAnalyticsKey: '_ga',
    userTagKey: 'ut',
    storageKey: `oidc.user:${config.AUTH_ENDPOINT}realms/${config.KEYCLOAK_REALM}:${config.KEYCLOAK_CLIENT_ID}`,
    pageHistoryKey: 'pageHistory',
    wpnp: '/wp-admin/admin-ajax.php?action=notification',
  };

  return defaults;
};

// check viewport
export const ppViewport = (): { width: number; height: number } => {
  let e: Window | HTMLElement = window;
  let a: 'inner' | 'client' = 'inner';

  if (!('innerWidth' in window)) {
    a = 'client';
    e = document.documentElement || document.body;
  }

  if (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeof (e as any)[a + 'Width'] === 'undefined' ||
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeof (e as any)[a + 'Height'] === 'undefined'
  ) {
    throw new Error('Viewport dimensions could not be determined.');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return { width: (e as any)[a + 'Width'], height: (e as any)[a + 'Height'] };
};

// function set/get from localStorage
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ppSetGet(varName: string, notifyData: number | any = 0) {
  if (0 === notifyData) {
    const storedData = localStorage.getItem(varName);

    return storedData ? JSON.parse(storedData) : null;
  } else {
    localStorage.setItem(varName, JSON.stringify(notifyData));
  }
}

// on click buttons move notification to history
export function ppChangeStatus(status: string | number, notification: Notification): void {
  let clicker = 0;

  if (1 == clicker) return;

  const { liveChat: user } = getStorage();
  const { wpnp } = getVariables();
  const email = user ? JSON.parse(user).email : null;

  fetch(config.WORDPRESS_URL + wpnp + '_confirm', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: 'email=' + email + '&notify=' + notification.id + '&status=' + status,
  })
    .then(function (response) {
      return response.json();
    })
    .then(() => {
      clicker = 0;
    });
}

// move notification to Read
export function ppRemoveNotification(
  notification: Notification,
  setStorageNots: (notifications: NotificationsStorage) => void,
): void {
  const { notificationKey } = getVariables();
  const notifications = ppSetGet(notificationKey);
  const campId = notification.id;

  // Find element in stored data and move it to read
  if (notifications) {
    notifications.new.forEach((item: Notification, i: number) => {
      if (campId === item.id) {
        notifications.read.push(item);
        notifications.new.splice(i, 1);
      }
    });

    if (Boolean(notifications.popup) && notifications.popup.length > 0) {
      notifications.popup.forEach((item: Notification, i: number) => {
        if (campId === item.id) {
          notifications.popup.splice(i, 1);
        }
      });
    }

    ppSetGet(notificationKey, notifications);
    setStorageNots(notifications);
  }
}

// extract value from path
export function ppGetValueFromUrl(path: string) {
  const match = path.match(/b_(\d+)c/);

  return match ? match[1] : 'default';
}

// Normalize search params to lowercase keys
export function normalizeSearchParams(searchParams: URLSearchParams): Record<string, string> {
  const normalized: Record<string, string> = {};

  for (const [key, value] of searchParams.entries()) {
    normalized[key.toLowerCase()] = value;
  }
  return normalized;
}
